export default {
  SET_TESTIMONIAL: function (state, payloads) {
    state.testimonials = payloads;
  },
};
